module.exports = __webpack_public_path__ + "img/I made it.ff0331dd.png";